import { Tabs } from "@mantine/core";
import * as React from "react";

const classnames = (props) =>
  Object.keys(props || {})
    .filter((k) => props[k])
    .join(" ");

export interface ITabBaseState {
  tab?: string;
}

export interface ITabProps {
  isActive?: boolean;
}

export abstract class TabBase<
  P,
  S extends ITabBaseState,
  TP extends ITabProps,
> extends React.PureComponent<P, S> {
  _mounted = false;

  constructor(props, content) {
    super(props, content);

    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
  }

  toggle(tabKey) {
    this.setState((state) => ({ ...state, tab: tabKey?.toLowerCase() }));
  }

  abstract getTabs(): { [tab: string]: React.ElementType<TP> };

  getTabView(tabProps: Omit<TP, "isActive">) {
    const tab = this.state.tab?.toLowerCase();
    const tabs = this.getTabs();
    const tabKeys = Object.keys(tabs);
    const activeTab = tab || tabKeys[0]?.toLowerCase();

    return (
      <Tabs value={activeTab} onChange={this.toggle} color="blue">
        <Tabs.List>
          {tabKeys.map((k) => (
            <Tabs.Tab key={k} value={k.toLowerCase()}>
              {k}
            </Tabs.Tab>
          ))}
        </Tabs.List>

        {tabKeys.map((k) => (
          <Tabs.Panel key={k} value={k.toLowerCase()} pt="sm">
            {React.createElement(tabs[k], {
              ...tabProps,
              isActive: k.toLowerCase() === activeTab,
            } as TP)}
          </Tabs.Panel>
        ))}
      </Tabs>
    );
  }
}
